import { z } from "zod";
import type { ReturnMode } from "../types";

export const RETURN_MODE_OPTIONS: ReturnMode[] = ["carrier", "store", "retractation"];

export const returnMethodSchema = z.object({
  mode: z.enum(["carrier", "store", "retractation"] as const),
});

export type ReturnMethodFormValues = z.infer<typeof returnMethodSchema>;
